/* eslint-disable no-underscore-dangle */
import React from 'react'
import { onButtonTriggerKey } from '../../utils'
import { toFrwClassName } from '../..'

export type RatingOutlookCellProps = {
  cellProps: any
  isPrintPreview?: boolean
  handleClick: () => void
}

export const ratingOutlookFilter = (filterItem: any, data: any) => {
  const filter = filterItem.value.toLowerCase()
  const { ratingOutlook } = data._original

  return ratingOutlook && ratingOutlook.toLowerCase().includes(filter)
}

export const RatingOutlookCell = (props: RatingOutlookCellProps) => {
  const { cellProps, handleClick, isPrintPreview = false } = props
  const { ratingOutlookCode = '', ratingOutlook = '' } = cellProps.original
  const iconClick = () => {
    handleClick()
  }
  return (
    <>
      {ratingOutlookCode ? (
        <div className="frw-ratings-key">
          {isPrintPreview ? (
            `${ratingOutlook}`
          ) : (
            <span
              aria-label={`Open popup for rating outlook keys. Current outlook: ${ratingOutlook}`}
              role="button"
              className={`${toFrwClassName(ratingOutlookCode)}`}
              onClick={iconClick}
              onKeyDown={onButtonTriggerKey(iconClick)}
              tabIndex={0}
              style={{ cursor: 'pointer' }}
            />
          )}
        </div>
      ) : null}
    </>
  )
}
export default RatingOutlookCell
